var DialogBehaviour = require('./dialog').Behavior;
var Controller = Marionette.Controller.extend({
    initialize: function (options) {
        this.container = options.container;
        this.view = new ConfirmDialog();
        this.container.show(this.view);
    }
});

require('./confirm-dialog/confirm-dialog.scss');
var ConfirmDialog = Marionette.LayoutView.extend({
    confirmClicked: false,
    cancelClicked: false,
    channel: null,
    className: 'tl-confirm-dialog',
    template: require('./confirm-dialog/confirm-dialog.tpl'),
    regions: {
        contentViewRegion: '.tl-content-view-region'
    },
    behaviors: {
        Modal: {
            behaviorClass: DialogBehaviour
        }
    },
    initialize: function (options) {
        var self = this;
        self.options = _.defaults(
            options || {},
            {
                customClassName: null,
                title: null,
                confirmText: null,
                cancelButtonLabel: 'Cancel',
                showCancelButton: true,
                confirmButtonLabel: 'OK',
                // beforeConfirmedCallback can be used to prevent the user
                // from confirming (and therefore closing) the dialog
                // when the confirm button is clicked.
                beforeConfirmedCallback: null,
                confirmedCallback: null,
                cancelledCallback: null,
                contentView: null,
                showSecondaryConfirmButton: false,
                secondaryConfirmButtonLabel: null,
                beforeSecondaryConfirmedCallback: null,
                secondaryConfirmedCallback: null,

            }
        );
        self.channel = options.channel || Radio.channel('dialog');
        self.on('close', self._mayTriggerCancelledCallback.bind(self));
        self.trigger('modal:open');
    },
    events: {
        'click .tl-primary-confirm-btn': '_confirmClicked',
        'click .tl-secondary-confirm-btn': '_secondaryConfirmClicked',
        'click .tl-cancel-btn': '_cancelClicked'
    },
    _mayTriggerCancelledCallback: function () {
        if (!this.cancelClicked && !this.confirmClicked && this.options.cancelledCallback) {
            this.options.cancelledCallback();
        }
    },
    _confirmClicked: function () {
        if (!this.options.beforeConfirmedCallback ||
            this.options.beforeConfirmedCallback(this.contentViewRegion.currentView))
        {
            if (this.options.confirmedCallback) {
                this.options.confirmedCallback();
            }
            this.confirmClicked = true;
            this.close();
        }
    },
    _secondaryConfirmClicked: function () {
        if (!this.options.beforeSecondaryConfirmedCallback ||
            this.options.beforeSecondaryConfirmedCallback(this.contentViewRegion.currentView))
        {
            if (this.options.secondaryConfirmedCallback) {
                this.options.secondaryConfirmedCallback();
            }
            this.confirmClicked = true;
            this.close();
        }
    },
    close: function () {
        this.trigger('modal:close');
    },
    _cancelClicked: function () {
        this._mayTriggerCancelledCallback();
        this.cancelClicked = true;
        this.close();
    },
    serializeData: function () {
        return {
            options: this.options
        };
    },
    setView: function (view) {
        this.contentViewRegion.show(view);
    },
    getDialog: function () {
        return this.dialog;
    },
    onRender: function () {
        if (this.options.contentView) {
            this.contentViewRegion.show(this.options.contentView);
        }
        this.$el.addClass(this.options.customClassName);
    }
});

module.exports = {
    Controller: Controller,
    View: ConfirmDialog
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/vendor/treeline-shared-components/confirm-dialog.js
 ** module id = 676
 ** module chunks = 1 2 108
 **/